/**
 * Clamp Faulty qty so it never exceeds pieces received in this batch.
 */
export function clampFaultyQuantity(quantityReceived, faultyQuantity) {
  const received = Math.max(0, parseInt(quantityReceived, 10) || 0);
  const faulty = Math.max(0, parseInt(faultyQuantity, 10) || 0);
  return Math.min(faulty, received);
}

export function okQuantityFromReceive(quantityReceived, faultyQuantity) {
  const received = Math.max(0, parseInt(quantityReceived, 10) || 0);
  return received - clampFaultyQuantity(received, faultyQuantity);
}

/**
 * Shape sent to PUT /inbounds/items and PUT /inbounds/rto.
 * Prefer faultyQuantity; keep legacy `faulty` when the whole batch is Faulty.
 */
export function withFaultyFields({ quantityReceived, faultyQuantity = 0, ...rest }) {
  const received = Math.max(0, parseInt(quantityReceived, 10) || 0);
  const faultyQty = clampFaultyQuantity(received, faultyQuantity);
  return {
    ...rest,
    quantityReceived: received,
    faultyQuantity: faultyQty,
    faulty: received > 0 && faultyQty === received,
  };
}
